import { render, staticRenderFns } from "./VFormItemPhones.vue?vue&type=template&id=276aa8b2&"
import script from "./VFormItemPhones.vue?vue&type=script&lang=js&"
export * from "./VFormItemPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276aa8b2')) {
      api.createRecord('276aa8b2', component.options)
    } else {
      api.reload('276aa8b2', component.options)
    }
    module.hot.accept("./VFormItemPhones.vue?vue&type=template&id=276aa8b2&", function () {
      api.rerender('276aa8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemPhones.vue"
export default component.exports